<template>
  <div class="cover-div" @click="addpic()"></div>
</template>

<script>
  export default {
    name: 'my_img_cover',
    props: {
      firstModel: {
        type: String,
        default: ''
      },
      fileType: {
        type: Number,
        default: 1
      },
      isEditMode: {
        type: Boolean,
        default: false
      },
      showFontIcon: {
        type: Boolean,
        default: false
      },
      showIconLibrary: {
        type: Boolean,
        default: false
      },
      selectLine: {
        type: Number,
        default: 0
      },
      sePicTab: {
        type: String,
        default: 'img'
      },
    },
    data() {
      return {
        first_model: this.firstModel
      }
    },
    methods: {
      addpic() {
        const that = this;
        let filePath = ''
        // this.$store.commit('image_upload/set_fileType', this.fileType);
        // this.$store.commit("image_upload/set_showTag", true, this.isEditMode);
        // this.$store.commit('image_upload/set_fileLimit', 1);
        // this.$store.commit("image_upload/set_showFontIcon", this.showFontIcon);
        // this.$store.commit("image_upload/set_showIconLibrary", this.showIconLibrary);
        // this.$store.commit("image_upload/set_selectLine", this.selectLine);
        // this.$store.commit("image_upload/set_sePicTab", this.sePicTab);
        this.$store.state.image_upload.imgFile = e => {
          if(typeof e[0].filePath !== 'undefined') {
              filePath = e[0].filePath;
          } else {
            filePath = e[0];
          }
          that.first_model = filePath;
          that.$store.state.image_upload.imgFile = null
        }

        this.$store.commit('image_upload/set_fileType', 1)
        this.$store.commit('image_upload/set_fileLimit', 1)
        this.$store.commit("image_upload/set_showTag", true)
        this.$store.commit("image_upload/set_showFontIcon", false);

        this.$store.commit("image_upload/set_showIconLibrary", false);// 是否显示图标库
        if(this.showIconLibrary) {
          this.$store.commit("image_upload/set_selectLine", 1);
          this.$store.commit("image_upload/set_sePicTab", 'icon');
        }

      // this.$store.state.image_upload.imgFile = (e) => {
      //   // this.url = e[0].filePath
      // }
      },
    },
    mounted() {
      if (this.fileType !== 0) {
        this.$store.commit("image_upload/set_fileType", this.fileType);
      }
    },
    watch: {
      first_model(val, oldVal) { // 数据双向绑定
        this.$emit('update:firstModel', val)
      },
      firstModel(val) { // 数据双向绑定
        this.first_model = val
      }
    },
  }
</script>

<style scoped>
  .cover-div{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/my_img_cover/index.vue